module.exports = __webpack_public_path__ + "img/bannerHelp_2.fb539cfb.png";